// extracted by mini-css-extract-plugin
module.exports = {"logo":"NavBarPublic_logo__3UgV9","header":"NavBarPublic_header__2RWVY"};